// extracted by mini-css-extract-plugin
export default {"modal-content":"styles_modal-content__XnKzQ"};